import { Link } from 'react-router-dom'
import { useAppDispatch } from '../../../../redux/hook'
import { Formik, FormikHelpers } from 'formik'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { LOGIN } from '../../../../redux/slices/authSlice'
import { Button, InputField, SwitchButton } from '../../../../components'
import { PageRoute } from '../../../../routes'
import { LoginSchema } from '../../schema'
import { LoginFormValues } from '../../type'
import { useTranslation } from 'react-i18next'
import { getProfile, login } from '../../api'
import { User } from '../../slice/userSlice'
import { decryptData, encryptData, getCookie } from './utils'
import { useEffect, useState } from 'react'

const LoginForm = () => {
    const initialValues = {
        email: '',
        password: '',
        isRemember: false,
    }

    const [decryptedValues, setDecryptedValues] = useState<LoginFormValues>()

    useEffect(() => {
        const encryptedData = getCookie('user')
        if (encryptedData) {
            const obj = decryptData(encryptedData)
            setDecryptedValues(obj)
        }
    }, [])

    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const handleLogin = async (
        values: LoginFormValues,
        actions: FormikHelpers<LoginFormValues>
    ) => {
        dispatch(SHOW_LOADER())
        const form = {
            email: values.email,
            password: values.password,
        }
        if (values.isRemember) {
            document.cookie = `user=${encryptData({ ...form, isRemember: values.isRemember })}`
        } else {
            // Check if 'isRemember' is false and cookie 'user' exists
            const userCookie = getCookie('user')
            if (userCookie) {
                // Delete the 'user' cookie
                document.cookie = 'user=;'
            }
        }
        const loginResponse = await login(form)
        const userResponse = loginResponse?.data
        if (userResponse) {
            dispatch(
                LOGIN({
                    isUser: true,
                    token: userResponse.token,
                    refreshToken: userResponse.refreshToken,
                })
            )
            dispatch(HIDE_LOADER())
            const userPersonalProfile = await getProfile()
            dispatch(
                User({
                    role: userPersonalProfile.data.role,
                    firstName: userPersonalProfile.data.firstName,
                    email: userPersonalProfile.data.email,
                    id: userPersonalProfile.data.id,
                    lastName: userPersonalProfile.data.lastName,
                    image: userPersonalProfile.data.imageUrl
                        ? userPersonalProfile.data.imageUrl
                        : null,
                    locationId: userPersonalProfile.data.locationId,
                    leavePolicyId: userPersonalProfile.data.leavePolicyId,
                })
            )
        }

        actions.setSubmitting(false)
    }

    return (
        <div className="auth-form">
            <Formik
                initialValues={
                    decryptedValues ? decryptedValues : initialValues
                }
                enableReinitialize
                validationSchema={LoginSchema}
                onSubmit={handleLogin}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <InputField
                            type="email"
                            lable={t('lable.email')}
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.email}
                            touched={touched.email}
                        />
                        <InputField
                            type="password"
                            lable={t('lable.password')}
                            name="password"
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.password}
                            touched={touched.password}
                        />
                        <SwitchButton
                            lable={t('button.rememberMe')}
                            onChange={handleChange}
                            name="isRemember"
                            value={values.isRemember}
                        />
                        <div>
                            <Button type="submit" disabled={isSubmitting}>
                                {t('button.login')}
                            </Button>
                        </div>
                        <Link
                            className="ms-2 mt-4 link d-flex justify-content-center align-items-center justify-center"
                            to={PageRoute.Forgot}
                        >
                            {t('auth.login.forgotPassword')}
                        </Link>
                    </form>
                )}
            </Formik>
        </div>
    )
}
export default LoginForm
